import React from "react";
import Box from "@mui/material/Box";
import { SxProps, Theme } from "@mui/material/styles";
import { MainProps } from "types";

const PANEL_SX: SxProps<Theme> = (theme: Theme) => ({
  flex: 1,
  backdropFilter: "blur(4px)",
  bgcolor: "background.paper",
  borderTopLeftRadius: Number(theme.shape.borderRadius) * 3,
  borderTopRightRadius: Number(theme.shape.borderRadius) * 3,
  overflow: "hidden",
  px: "1.5rem",
  pt: "2.5rem",
});

const CONTENT_SX: SxProps<Theme> = {
  maxWidth: "28rem",
  mx: "auto",
  color: "text.primary",
};

const Main = ({ children, sx = PANEL_SX, contentSx = CONTENT_SX }: MainProps): JSX.Element => (
  <Box sx={sx}>
    <Box sx={contentSx}>{children}</Box>
  </Box>
);

export default Main;
